import { Component, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import { OrigenDeFondos } from 'app/main/models/origen-de-fondos.model';
import {PaisService} from '../../../../services/pais.service';


@Component({
  selector: 'tipo-sujeto-obligado-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss']
})
export class OrigenDeFondosDialogBoxComponent {

  action: string;
  LOCAL_DATA: any;

  roles = [];
  empresas = [];
  paises = [];


    constructor(
    public dialogRef: MatDialogRef<OrigenDeFondosDialogBoxComponent>,
    public translate: TranslateService,
    private servicePais: PaisService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: OrigenDeFondos) {
    console.log(data);
    this.LOCAL_DATA = {...data};
    this.action = this.LOCAL_DATA.action;
  }

  doAction(): void{
    console.log('im here');
    this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {

      this.servicePais
          .getList()
          .pipe()
          .subscribe((req) => {
              this.paises = req.body.map((tipo) => {
                  console.log(tipo);
                  return {
                      id: tipo.id,
                      nombre: tipo.nombre,
                  };
              });
          });
  }

    compareObjects(o1: any, o2: any): boolean {
        var equals = false;
        if (
            o1 != null &&
            o2 != null &&
            typeof o1 === "object" &&
            typeof o2 === "object" &&
            "id" in o1 &&
            "id" in o2 &&
            o1.id === o2.id
        ) {
            equals = true;
        } else {
            equals = o1 == o2 ? true : false;
        }

        return equals;
    }

}
